import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Router, RouterLink } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AuthValidationError, ForgotPasswordFailure, ForgotPasswordRequest, ForgotPasswordSuccess } from '../../../store/auth/auth.actions';
import { take } from 'rxjs/internal/operators/take';
import { ValidationErrorComponent } from '../../../components/core/validation-error/validation-error.component';
import { BRANDING } from '../../../core/config/branding';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCardModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    RouterLink,
    ValidationErrorComponent
  ],
  templateUrl: './forgot-password.html',
  styleUrl: './forgot-password.scss',
})
export class ForgotPassword {
  protected readonly brand = BRANDING;
  private readonly formBuilder = inject(FormBuilder);
  private readonly store = inject(Store);
  private readonly actions$ = inject(Actions);
  private readonly router = inject(Router);
  validationError = signal<string[]>([]);

  protected readonly forgotForm = this.formBuilder.group({
    countryCode: ['+1', [Validators.required]],
    phone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
  });

  protected onSubmit(): void {
    this.validationError.set([]);
    if (this.forgotForm.invalid) {
      this.forgotForm.markAllAsTouched();
      return;
    }

    const formValue = this.forgotForm.getRawValue();
    const phone = `${formValue.countryCode ?? ''}${formValue.phone ?? ''}`;

    this.store.dispatch(ForgotPasswordRequest({ payload: { phone } }));
    this.actions$.pipe(ofType(ForgotPasswordSuccess)).pipe(take(1)).subscribe(() => {
      this.router.navigate(['/auth/login']);
    });

    this.actions$.pipe(ofType(AuthValidationError)).pipe(take(1)).subscribe(({ validationError }) => {
      this.validationError.set(validationError);
    });

    this.actions$.pipe(ofType(ForgotPasswordFailure)).pipe(take(1)).subscribe(({ error }) => {
      this.validationError.set([error]);
    });
  }
}
